import type { TwoStepMethodKind, TwoStepStatus } from '../../../../../@api-client';

export type TwoStepUsing = TwoStepMethodKind | 'support-code';

export type TwoStepSetupMethod =
  { kind: 'authenticator'; secret: string; uri: string } | { kind: 'sms'; hint?: string };

export type TwoStepSetupStep = {
  name: 'setup';
  email?: string;
  kinds: TwoStepMethodKind[];
  phoneOnRecord?: string;
  askingPhone?: boolean;
  changingNumber?: boolean;
  method?: TwoStepSetupMethod;
};

export type TwoStepVerifyStep = {
  name: 'verify';
  email?: string;
  methods: TwoStepStatus['methods'];
  rememberDays?: number;
  offersSupportCode: boolean;
  using: TwoStepUsing;
};

export type TwoStepStep = TwoStepSetupStep | TwoStepVerifyStep;

export type TwoStepError = { code?: string; message: string };

export type TwoStepFeedback = {
  busy: boolean;
  error: TwoStepError | null;
  notice: string | null;
};

export type TwoStepActions = {
  chooseMethod: (kind: 'authenticator') => void;
  askForPhone: () => void;
  submitPhone: (phoneNumber: string) => void;
  confirmMethod: (code: string) => void;
  chooseAnotherSetupMethod: () => void;
  submitCode: (code: string, rememberDevice: boolean) => void;
  switchMethod: (using: TwoStepUsing) => void;
  resendCode: () => void;
};

export const TWO_STEP_FIELD_REFUSALS = {
  code: 'TWO_STEP_INCORRECT_CODE',
  phoneNumber: 'TWO_STEP_INVALID_PHONE',
  phoneCountry: 'TWO_STEP_COUNTRY_UNSUPPORTED',
} as const;

/** The API's refusal to send another code yet: too soon after the last, or too many this hour. */
export const TWO_STEP_SEND_LIMIT = 'TWO_STEP_SEND_LIMIT';
